export function safePositiveId(value: number | null | undefined): value is number {
  return Number.isSafeInteger(value) && (value ?? 0) > 0;
}

/** The Queue screen handles these original Amelia identifiers, including past bookings. */
export function purchaseBookingLink(bookingId: number | null | undefined, appointmentId: number | null | undefined): string | null {
  if (!safePositiveId(bookingId) || !safePositiveId(appointmentId)) return null;
  return `/waiting?queue=unmatched&amelia_booking_id=${bookingId}&amelia_appointment_id=${appointmentId}`;
}
